module.exports = __webpack_public_path__ + "static/media/profile-pic.5a99d3ff.jpeg";